'use client'

import * as React from 'react'
import * as ProgressPrimitive from '@radix-ui/react-progress'
import { cn } from '@/lib/utils'

const LoadingBar = React.forwardRef<
  React.ElementRef<typeof ProgressPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof ProgressPrimitive.Root>
>(({ className, ...props }, ref) => (
  <ProgressPrimitive.Root
    ref={ref}
    className={cn(
      'relative h-1.5 w-full overflow-hidden rounded-full bg-gray-900/20',
      className,
    )}
    {...props}
  >
    <ProgressPrimitive.Indicator className="h-full w-full flex-1 animate-loading-bar bg-gray-900 transition-all" />
  </ProgressPrimitive.Root>
))
LoadingBar.displayName = ProgressPrimitive.Root.displayName

export { LoadingBar }
